export default __webpack_public_path__ + "static/media/sinthuja.6cbeb5f8.jpeg";